/**
 * JURO — add the cart upsell without leaving the cart
 * ------------------------------------------------------------------
 * Delegated from document because the theme morphs the cart markup. Posts to
 * /cart/add.js with the cart sections, then dispatches the theme's cart:update
 * so the drawer or cart page redraws (the upsell removes itself in Liquid).
 * Guarded because the drawer and the cart page can both load this file.
 */

import { CartAddEvent } from '@theme/events';

if (!window.__juroCartUpsell) {
  window.__juroCartUpsell = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest && event.target.closest('[data-juro-upsell]');
    if (!button || button.disabled) return;
    button.disabled = true;

    try {
      const sections = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.juroUpsell), quantity: 1 }],
          sections: sections.join(','),
        }),
      }).then((r) => r.json());

      if (res.status) {
        button.disabled = false;
        return;
      }

      document.dispatchEvent(
        new CartAddEvent({}, 'juro-cart-upsell', {
          source: 'juro-cart-upsell',
          itemCount: 1,
          sections: res.sections,
        })
      );
    } catch (e) {
      button.disabled = false;
    }
  });
}
